import React from 'react'
import ProductFeature from './ProductFeatures'
import { ISharedFeatures } from '../types'

// MUI
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

const SharedFeatures = ({
  sharedFeaturesTitle,
  sharedFeaturesAreStacked = false,
  sharedFeatureItems,
}: ISharedFeatures) => {
  const { palette } = useTheme()
  const styles = {
    root: {
      borderTop: `solid 1px ${palette.grey[300]}`,
    },
    sharedFeaturesContent: {
      padding: '32px',
    },
    sharedFeaturesTitle: {
      marginBottom: '16px',
    },
  }
  return (
    <Grid component="tr" sx={styles.root} container>
      <Grid component="td" item xs={12}>
        <Box sx={styles.sharedFeaturesContent}>
          {sharedFeaturesTitle && (
            <Typography sx={styles.sharedFeaturesTitle} variant="subtitle1">
              {sharedFeaturesTitle}
            </Typography>
          )}
          <ProductFeature isStacked={sharedFeaturesAreStacked} features={sharedFeatureItems} />
        </Box>
      </Grid>
    </Grid>
  )
}

export default SharedFeatures
